import axios from 'axios';

const API_URL = "https://api.thunderbirdsmoke.net/api/settings/shipping";

// 🔐 Helper to add Authorization header
const authHeader = () => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    throw new Error("No auth token found");
  }
  return { Authorization: `Bearer ${token}` };
};

/**
 * 🔹 Admin Shipping Rate APIs
 */

// GET all shipping rates per location
export const getShippingRates = async () => {
  try {
    const res = await axios.get(API_URL, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Failed to fetch shipping rates:", error);
    throw error;
  }
};

// UPDATE flat shipping rate for a location
export const updateShippingRate = async (
  locationId: number,
  flatRate: number,
  freeShippingMinimum: number
) => {
  try {
    const res = await axios.put(`${API_URL}/${locationId}`, {
      flat_shipping_rate: flatRate,
      free_shipping_minimum: freeShippingMinimum,
    }, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Failed to update shipping rate:", error);
    throw error;
  }
};

